module.exports = "/_next/static/images/succeed-e5c342399a20cf5de9aa4d5705101117.png";